import { Component, OnInit } from '@angular/core';
import { Pregunta } from '../../_models/pregunta';
import { PreguntaRespuesta } from '../../_models/pregunta-respuesta';
import { BancoPreguntasService } from '../../_services/banco-preguntas.service';
import { RespuestaService } from '../../_services/respuesta.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Params } from '@angular/router';
import { forkJoin } from 'rxjs';
import { NavService } from '../../_services/_nav.service';

@Component( {
  selector: 'app-banco-preguntas-detalle',
  templateUrl: 'banco-preguntas-detalle.component.html'
} )

export class BancoPreguntasDetalleComponent implements OnInit {

  pregunta: Pregunta;
  respuestas: PreguntaRespuesta[] = [];
  carInformacionInicial = true;
  colRespuestas: any[] = [];

  constructor( private preServicio: BancoPreguntasService,
               private route: ActivatedRoute,
               private navServicio: NavService,
               private resServicio: RespuestaService,
               private location: Location ) {
  }

  ngOnInit(): void {
    this.colRespuestas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'PREGUNTAS.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'PREGUNTAS.LBL_FORMRESPUESTA' ), sort: false },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false }
    ];

    this.route.params.subscribe( ( params: Params ) => {
      forkJoin(
        this.preServicio.obtener( params[ 'id' ] ),
        this.resServicio.listadoByPregunta( params[ 'id' ] )
      ).subscribe( ( [ pregunta, respuestas ] ) => {
        this.pregunta = pregunta;
        this.respuestas = respuestas;
        this.carInformacionInicial = false;
      } );
    } );
  }

  regresar() {
    this.location.back();
  }
}
